import type { RouteDefinition } from '@/types';
import { todayIsoDate } from './date';

/** True when a catalog route could be assigned on the selected admin date. */
export const isRouteAvailableOnDate = (route: RouteDefinition, date: string): boolean => {
  const today = todayIsoDate();
  const createdDate = route.createdAt?.slice(0, 10);

  if (createdDate && date < createdDate) return false;
  if (route.activeFrom && date < route.activeFrom) return false;
  if (route.activeUntil && date > route.activeUntil) return false;
  return date !== today || route.active;
};
